import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: "O ebook funciona para qualquer raça de cão?",
      answer: "Sim! As técnicas ensinadas no ebook são baseadas em princípios de comportamento canino que funcionam para todas as raças, desde pequenos Chihuahuas até grandes Pastores Alemães. O método é adaptável ao tamanho, idade e temperamento do seu cão."
    },
    {
      question: "Quanto tempo leva para ver resultados?",
      answer: "A maioria dos tutores começa a ver resultados significativos nas primeiras 2-3 semanas de treinamento consistente. Comandos básicos podem ser aprendidos em poucos dias, enquanto correções de comportamento mais complexas podem levar de 4 a 8 semanas, dependendo do caso."
    },
    {
      question: "Funciona com cães adultos ou apenas filhotes?",
      answer: "O ebook funciona tanto para filhotes quanto para cães adultos! Embora filhotes aprendam mais rápido, cães adultos também podem ser treinados com sucesso usando nossas técnicas de reforço positivo. Nunca é tarde para ensinar novos comportamentos ao seu cão."
    },
    {
      question: "Preciso de equipamentos especiais?",
      answer: "Não! Você precisará apenas de itens básicos que a maioria dos tutores já possui: coleira, guia, petiscos para recompensa e brinquedos. O ebook ensina técnicas que não dependem de equipamentos caros ou especializados."
    },
    {
      question: "Como recebo o ebook após a compra?",
      answer: "Imediatamente após a confirmação do pagamento, você receberá um email com o link para download do ebook em formato PDF, além dos vídeos bônus e acesso ao grupo VIP. O acesso é instantâneo e vitalício."
    },
    {
      question: "E se o método não funcionar para meu cão?",
      answer: "Oferecemos garantia incondicional de 07 dias. Se você aplicar as técnicas e não ver resultados, ou simplesmente não ficar satisfeito, devolvemos 100% do seu dinheiro sem perguntas. Você não tem nada a perder!"
    },
    {
      question: "Posso tirar dúvidas durante o treinamento?",
      answer: "Sim! Você terá acesso ao nosso suporte por email e ao grupo VIP no WhatsApp, onde poderá tirar dúvidas, compartilhar experiências e receber orientações de nossa equipe e de outros tutores."
    },
    {
      question: "O ebook ensina a corrigir comportamentos agressivos?",
      answer: "Sim, temos um capítulo completo dedicado à correção de comportamentos problemáticos, incluindo agressividade, medo, ansiedade e hiperatividade. As técnicas são baseadas em reforço positivo e métodos comprovados cientificamente."
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A2463] mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-gray-600">
            Tire suas dúvidas antes de começar
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white border-2 border-gray-200 rounded-2xl overflow-hidden hover:border-[#FFB800] transition-colors duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left cursor-pointer hover:bg-gray-50 transition-colors duration-200"
              >
                <h3 className="text-lg font-bold text-[#0A2463] pr-4">
                  {faq.question}
                </h3>
                <div className={`w-8 h-8 bg-[#FFB800] rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-[#0A2463] text-xl"></i>
                </div>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 text-gray-700 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#0A2463] to-[#1E3A8A] rounded-3xl p-10 text-center">
          <div className="w-16 h-16 bg-[#FFB800] rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-question-answer-line text-[#0A2463] text-3xl"></i>
          </div>
          <h3 className="text-3xl font-bold text-white mb-4">
            Ainda tem Dúvidas ?
          </h3>
          <p className="text-xl text-gray-200 mb-6">
            Nossa equipe está pronta para ajudar você
          </p>
          <a 
            href="https://wa.me/5511942623635"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#FFB800] hover:bg-[#FFA500] text-[#0A2463] px-8 py-4 rounded-full text-lg font-bold transition-all duration-300 transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            <span>Fale Conosco</span>
          </a>
        </div>
      </div>
    </section>
  );
}